/* ============================================================
   to myself. — Scroll-Animationen & Interaktionen (Dawn)
   Läuft nur einmal, egal wie viele Sections eingebunden sind.
   ============================================================ */
(function () {
  document.documentElement.classList.add('tm-js');
  if (window.__tmThemeInit) return;
  window.__tmThemeInit = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Videos: Autoplay zuverlässig starten ----------
     iOS zeigt sonst ein Play-Symbol, wenn play() einmal scheitert
     (Energiesparmodus, Video noch nicht geladen, Rückkehr über den
     Zurück-Button). Deshalb: stumm + inline erzwingen und bei jedem
     sinnvollen Anlass erneut starten. */
  function tmVideoStarten(v) {
    if (!v.paused) return;
    if (document.documentElement.classList.contains('tm-menue-offen')) return;
    v.muted = true;
    var p = v.play();
    if (p && p.catch) { p.catch(function () {}); }
  }
  function tmAlleVideosStarten() {
    document.querySelectorAll('video[autoplay]').forEach(tmVideoStarten);
  }
  function tmVideoWaechter(root) {
    (root || document).querySelectorAll('video[autoplay]').forEach(function (v) {
      if (v.__tmAuto) return;
      v.__tmAuto = true;
      v.muted = true;
      v.setAttribute('muted', '');
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      ['loadeddata', 'canplay'].forEach(function (ev) {
        v.addEventListener(ev, function () { tmVideoStarten(v); });
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (x) { if (x.isIntersecting) tmVideoStarten(x.target); });
        }, { threshold: 0.05 }).observe(v);
      }
      tmVideoStarten(v);
    });
  }
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) tmAlleVideosStarten();
  });
  window.addEventListener('pageshow', function () { tmAlleVideosStarten(); });
  ['touchstart', 'click', 'scroll'].forEach(function (ev) {
    window.addEventListener(ev, tmAlleVideosStarten, { passive: true, once: true });
  });

  function init(root) {
    root = root || document;

    tmVideoWaechter(root);

    /* Gestaffelte Gruppen: Kinder bekommen automatisch Verzögerungen */
    root.querySelectorAll('[data-tm-stagger]').forEach(function (group) {
      var step = parseInt(group.getAttribute('data-tm-stagger'), 10) || 110;
      Array.prototype.forEach.call(group.children, function (child, i) {
        if (!child.hasAttribute('data-tm-reveal')) child.setAttribute('data-tm-reveal', group.getAttribute('data-tm-stagger-style') || '');
        child.style.transitionDelay = (i * step) + 'ms';
      });
    });

    /* Reveal beim Scrollen */
    var targets = root.querySelectorAll('[data-tm-reveal], .tm-draw');
    if (reduceMotion) {
      targets.forEach(function (el) { el.classList.add('tm-visible'); });
    } else if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('tm-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.18, rootMargin: '0px 0px -40px 0px' });
      targets.forEach(function (el) { io.observe(el); });
    } else {
      targets.forEach(function (el) { el.classList.add('tm-visible'); });
    }

    /* Sticker-Popover (Methode) */
    root.querySelectorAll('.tm-sticker').forEach(function (btn) {
      if (btn.__tmBound) return;
      btn.__tmBound = true;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var wasOpen = btn.classList.contains('tm-open');
        document.querySelectorAll('.tm-sticker.tm-open').forEach(function (o) { o.classList.remove('tm-open'); });
        if (!wasOpen) btn.classList.add('tm-open');
      });
    });

    /* Akkordeon (FAQ) */
    root.querySelectorAll('.tm-acc__q').forEach(function (q) {
      if (q.__tmBound) return;
      q.__tmBound = true;
      q.addEventListener('click', function () {
        var item = q.closest('.tm-acc');
        var panel = item.querySelector('.tm-acc__a');
        var open = item.classList.contains('tm-open');
        var wrap = item.parentElement;
        wrap.querySelectorAll('.tm-acc.tm-open').forEach(function (o) {
          o.classList.remove('tm-open');
          o.querySelector('.tm-acc__a').style.maxHeight = null;
          o.querySelector('.tm-acc__q').setAttribute('aria-expanded', 'false');
        });
        if (!open) {
          item.classList.add('tm-open');
          panel.style.maxHeight = panel.scrollHeight + 'px';
          q.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  document.addEventListener('click', function () {
    document.querySelectorAll('.tm-sticker.tm-open').forEach(function (o) { o.classList.remove('tm-open'); });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* Shopify Theme-Editor: Sections neu initialisieren, wenn sie neu geladen werden */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
